import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

import { ReactComponent as Mail } from 'assets/images/mail.svg';
import { ReactComponent as Phone } from 'assets/images/phone.svg';

export const Container = styled.div`
  padding-top: 30px;
  display: flex;
  flex-direction: column;
`;

export const Header = styled.h1`
  color: ${ColorPalette.HEX.CharlestonGreen};
  font-size: 14px;
  line-height: 12px;
  font-weight: 600;
  margin-bottom: 24px;

  @media ${({ theme }) => theme.device.desktop} {
    font-size: 18px;
    line-height: 48px;
    margin-bottom: 0px;
  }
`;

export const Detail = styled.h2`
  color: ${ColorPalette.HEX.DimGray};
  font-size: 12px;
  line-height: 18px;
  margin-bottom: 6px;

  @media ${({ theme }) => theme.device.desktop} {
    font-size: 14px;
  }
`;

export const Countries = styled.ul``;

export const Country = styled.li`
  margin: 0px 0;
`;

export const CountryName = styled.h3`
  font-size: 14px;
  font-weight: 600;
  line-height: 1.4;
  letter-spacing: -0.2px;
  color: ${ColorPalette.HEX.DimGray};
`;

export const Channel = styled.div`
  margin: 8px 0;
  display: flex;
  align-items: center;
  color: ${ColorPalette.HEX.DimGray};
`;

export const ChannelInfo = styled.p`
  margin: 0 0px;
  font-size: 14px;
  font-weight: normal;
  line-height: 1.4;
  letter-spacing: -0.2px;
  color: ${ColorPalette.HEX.DimGray};
`;

export const MailIcon = styled(Mail)`
  width: 18px;
  margin-right: 10px;
`;

export const PhoneIcon = styled(Phone)`
  width: 18px;
  margin-right: 10px;
`;
